import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { LocationController } from "./locations.controller";
import { LocationService } from "./locations.service";
import { LocationAdapater} from "../locations/dto/location-adpater";
import {Location} from '../locations/dto/loction-entity';
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";



@Module({
    imports: [
    TypeOrmModule.forFeature([Location]),
    ],
    controllers: [LocationController],
    providers: [LocationService, LocationAdapater,ApplicationExceptionHandler ],
    exports: [TypeOrmModule],
})
export class LocationModule { }
